<template>
  <div>
    <template v-if="battery !== null">
      <template v-if="this.user.roles[0] != 'EC_USER'">
        <template v-if="$vuetify.breakpoint.mdAndUp">
          <BottomNavigationControl :mppt="mppt" :dab="battery.batteries" />
        </template>

        <template v-if="$vuetify.breakpoint.smAndDown">
          <BottomNavigationControl :mppt="mppt" :dab="battery.batteries" :panel="false" />
        </template>
      </template>

      <!-- {{ power }} -->

      <template v-if="'batteries' in battery">
        <template v-if="number === 0">
          <v-slide-group show-arrows="always" active-class="success" class="my-2">
            <v-row justify="center">
              <v-slide-item v-for="(item, index) in battery.batteries" :key="index">
                <v-hover v-slot="{ hover }">
                  <v-card :disabled="item.state == 'Reset'" :elevation="hover ? 12 : 6" :dark="$vuetify.theme.dark" @click="setBattery(index + 1)" class="ma-4" height="230" width="400" :max-width="stationCardMaxWidth">
                    <v-expand-transition>
                      <div v-if="hover" class="d-flex transition-fast-in-fast-out primary v-card--reveal headline white--text" style="height: 100%">
                        <!-- {{ $t("charger.hover") }} -->
                        Zobrazit jednotlivé články
                        <!-- v sadě č.{{ index + 1 }} -->
                      </div>
                    </v-expand-transition>
                    <v-card-title class="white--text primary">
                      <!-- <div :class="item.state == 'Reset' ? 'blur' : ''"> -->
                      Battery {{ index + 1 }}
                      <!--  <br /></div> -->
                      <v-spacer />

                      <template v-if="master[index]">
                        <v-icon class="shadow" large color="white">mdi-battery-check</v-icon>
                      </template>
                      <template v-else>
                        <v-icon class="shadow" large color="white">mdi-battery</v-icon>
                      </template>
                    </v-card-title>

                    <v-card-text>
                      <template v-if="!hover">
                        <!-- <v-row class="overline" no-gutters> -->

                        <v-row :class="item.state == 'Reset' ? 'blur overline' : 'overline'" no-gutters>
                          <v-col cols="8">
                            <v-row no-gutters>
                              <v-col cols="12" dense>
                                <h4>
                                  CTRL: <b>{{ item.state }}</b>
                                </h4>
                              </v-col>
                              <v-col cols="12" dense>
                                <h4>
                                  <template v-if="'safety' in item">
                                    <template v-if="'state' in item.safety">
                                      SAFE: <b>{{ item.safety.state }}</b>
                                    </template>
                                  </template>
                                </h4>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="4">
                            <v-row no-gutters>
                              <template v-if="'bms' in item">
                                <template v-if="'soc' in item.bms">
                                  <v-col cols="6" class="mt-4">
                                    <template v-if="item.state === 'Reset'">
                                      <BatterySoC :SoC="item.bms.soc" :size="38" :Charging="item.bat.i < -0.1 ? true : false" :ChargingRate="item.bat.i" CustomColor="grey"></BatterySoC>
                                    </template>
                                    <template v-else>
                                      <BatterySoC :SoC="item.bms.soc" :size="38" :Charging="item.bat.i < -0.1 ? true : false" :ChargingRate="item.bat.i"></BatterySoC>
                                    </template>
                                  </v-col>
                                  <v-col cols="6" class="mt-4">
                                    <b>{{ item.bms.soc }} %</b>
                                  </v-col>
                                </template>
                              </template>
                            </v-row>
                          </v-col>
                        </v-row>

                        <v-row :class="item.state == 'Reset' ? 'blur caption my-4' : 'caption my-4'" no-gutters>
                          <v-col cols="6" align="center">
                            <v-row no-gutters>
                              <template v-if="'bat' in item">
                                <v-col cols="12">
                                  BAT: <b>{{ item.bat.u }} V {{ item.bat.i }} A </b>
                                </v-col>
                                <v-col cols="12">
                                  <b> {{ item.bat.power }} kW </b>
                                </v-col>
                              </template>
                              <template v-else>
                                <br />
                                <br />
                              </template>
                            </v-row>
                          </v-col>
                          <v-col cols="6" align="center">
                            <v-row no-gutters>
                              <template v-if="'dc' in item">
                                <v-col cols="12">
                                  DC: <b>{{ item.dc.u }} V {{ item.dc.i }} A </b>
                                </v-col>
                                <v-col cols="12">
                                  <b> {{ item.dc.power }} kW </b>
                                </v-col>
                              </template>
                              <template v-else>
                                <br />
                                <br />
                              </template>
                            </v-row>
                          </v-col>

                          <v-col cols="12">
                            <template v-if="item.state != 'Reset'">
                              <v-progress-linear rounded v-model="power[index]" :color="powerSign[index] == -1 ? 'lime' : 'light-green'" height="15">
                                <template v-slot:default="{ value }">
                                  <strong class="blue-grey--text"> {{ powerSign[index] == -1 ? "-" : "" }} {{ ((value / 100) * 10).toFixed(3) }} kW </strong>
                                </template>
                              </v-progress-linear>
                            </template>
                          </v-col>

                          <template v-if="'upTime' in item">
                            <v-col cols="4" class="mt-2">
                              Uptime: <b>{{ item.upTime }}</b> <br />
                            </v-col>
                          </template>
                          <template v-if="'serialNumber' in item">
                            <v-col align="end" cols="8" class="mt-2">
                              SN: <b>{{ item.serialNumber }}</b> <br />
                            </v-col>
                          </template>
                        </v-row>
                      </template>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-slide-item>
            </v-row>
          </v-slide-group>
        </template>
        <template v-else>
          <v-row>
            <v-col align="center" cols="1">
              <v-btn fab small raised color="primary" elevation="12" @click="setBattery(0)"><v-icon>mdi-keyboard-backspace</v-icon></v-btn>
            </v-col>

            <v-col align="center" cols="1"> </v-col>
          </v-row>
          <Batteries :number="number" :data="battery.batteries[this.number - 1].bms" :battery="battery" />
        </template>
      </template>
    </template>
    <UpgradeCore />
  </div>
</template>

<script>
import UpgradeCore from "../../components/upgrade/UpgradeCore.vue";

import Batteries from "../../components/battery/digital/Batteries.vue";
import BatterySoC from "../../components/battery/BatterySoC.vue";
import BottomNavigationControl from "../../components/navigation/BottomNavigationControl.vue";

import { ServiceClient } from "../../service_client/index.js";

export default {
  components: {
    BatterySoC,
    Batteries,
    BottomNavigationControl,
    UpgradeCore,
  },
  data() {
    return {
      number: 0,

      mppt: null,
      battery: null,

      skill: 20,

      master: [],
      power: [],

      stationCardMaxWidth: 0,

      timerDigital: null,

      mobile: false,

      user: JSON.parse(sessionStorage.getItem("user")),

      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.pollDigitalData();

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  created() {
    this.getBreakpoints();
    this.getDigitalData();
  },
  methods: {
    setBattery(value) {
      this.number = value;
    },
    onResize() {
      this.getBreakpoints();
    },
    getBreakpoints() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

      if (this.windowWidth < 768) {
        this.stationCardMaxWidth = this.windowWidth - (48 + 24);
        this.mobile = true;
      } else {
        this.stationCardMaxWidth = 330;
        this.mobile = false;
      }
    },
    pollDigitalData() {
      this.timerDigital = setInterval(() => {
        this.getDigitalData();
      }, 5000);
    },
    getDigitalData() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("main"), null, null, "GET")
        .then((data) => {
          this.mppt = data.mppt;
          this.battery = data.battery;

          let averageVoltage = [];
          let underVoltage = [];
          let overVoltage = [];
          let lowerOutOfRange = [];
          let higherOutOfRange = [];

          let labels;

          this.master = [];

          this.power = [];
          this.powerSign = [];

          let regexMaster = /\bIamMaster\b/;

          for (let i = 0; i < this.battery.batteries.length; i++) {
            this.battery.batteries[i].bms.cellsAvgVoltage = (Math.round(this.battery.batteries[i].bms.cellsAvgVoltage) / 1000).toFixed(3);
            this.battery.batteries[i].bms.cellsMaxVoltage = (Math.round(this.battery.batteries[i].bms.cellsMaxVoltage) / 1000).toFixed(3);
            this.battery.batteries[i].bms.cellsMinVoltage = (Math.round(this.battery.batteries[i].bms.cellsMinVoltage) / 1000).toFixed(3);

            if (this.battery.batteries[i].bat.power >= 0) {
              this.powerSign.push(1);
            } else {
              this.powerSign.push(-1);
            }

            this.power.push((Math.abs(this.battery.batteries[i].bat.power) / 10) * 100);

            if (regexMaster.test(this.battery.batteries[i].status)) {
              this.master.push(true);
            } else {
              this.master.push(false);
            }

            let temp;

            for (let j = 0; j < this.battery.batteries[i].bms.pack.length; j++) {
              labels = [];
              averageVoltage = [];
              underVoltage = [];
              overVoltage = [];
              lowerOutOfRange = [];
              higherOutOfRange = [];

              temp = parseInt(this.battery.batteries[i].bms.pack[j].balancingMask).toString(2).split("").reverse();
              this.battery.batteries[i].bms.pack[j].balancingArray = temp;

              for (let k = 0; k < this.battery.batteries[i].bms.pack[j].balancingArray.length; k++) {
                this.battery.batteries[i].bms.pack[j].balancingArray[k] *= 2.2;
              }

              for (let k = 0; k < this.battery.batteries[i].bms.pack[j].cellVoltages.length; k++) {
                this.battery.batteries[i].bms.pack[j].cellVoltages[k] = (Math.round(this.battery.batteries[i].bms.pack[j].cellVoltages[k]) / 1000).toFixed(3);

                labels.push(this.battery.batteries[i].bms.pack[j].cellVoltages[k] + " V");

                averageVoltage.push(this.battery.batteries[i].bms.cellsAvgVoltage);
                underVoltage.push(2.85);
                overVoltage.push(3.65);
                lowerOutOfRange.push(2.65);
                higherOutOfRange.push(3.85);
              }

              this.battery.batteries[i].bms.pack[j].averageVoltages = averageVoltage;
              this.battery.batteries[i].bms.pack[j].cellIndexes = labels;
              this.battery.batteries[i].bms.pack[j].overVoltage = overVoltage;
              this.battery.batteries[i].bms.pack[j].underVoltage = underVoltage;
              this.battery.batteries[i].bms.pack[j].lowerOutOfRange = lowerOutOfRange;
              this.battery.batteries[i].bms.pack[j].higherOutOfRange = higherOutOfRange;
            }
          }
        })
        .catch((error) => {
          this.battery = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
  },
  beforeDestroy: function () {
    clearInterval(this.timerDigital);

    window.removeEventListener("resize", this.onResize);
  },
  watch: {},
};
</script>

<style scoped>
.v-card--reveal {
  border-radius: 5px;

  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.8;
  position: absolute;
  width: 100%;
}

.shadow {
  text-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}

.blur {
  font-size: 40px;
  color: transparent;
  text-shadow: 0 0 8px #000;
}
</style>
